<template>
  <div class="app-wrapper">
    <nav-bar v-if="!$route.meta.isAlone" @on-refresh="onRefresh" @on-change-pwd="isSetShow = true"></nav-bar>
    <div :class="!$route.meta.isAlone ? 'main-container1':'main-container'" v-if="$store.state.companyId != '0'">
      <keep-alive>
        <Menu v-if="!$route.meta.isAlone" style="width:250px;" ref="menu"></Menu>
      </keep-alive>
      <app-main ref="appMain"></app-main>
    </div>
    <message ref="message"></message>
    <el-dialog title="修改密码" :modal-append-to-body="false" :append-to-body="false" :visible.sync="isSetShow"
      width="400px">
      <div class="p-20">
        <el-form>
          <el-form-item label="原密码" label-width="80px">
            <el-input v-model="oldPwd" type="password" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="新密码" label-width="80px">
            <el-input v-model="newPwd" type="password" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" label-width="80px">
            <el-input v-model="repeatPwd" type="password" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelPwd">取 消</el-button>
        <el-button type="primary" @click="submitPwd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import AppMain from '@/components/AppMain'
import NavBar from '@/components/NavBar'
import Message from '@/components/Message'
export default {
  name: 'index',
  components: { Menu, AppMain, NavBar, Message },
  data () {
    return {
      isSetShow: false,
      oldPwd: '',
      newPwd: '',
      repeatPwd: ''
    }
  },
  created () {
  },
  mounted () {
    // window.addEventListener('beforeunload', e => this.set())
  },
  methods: {
    // set () {
    //   this.$store.dispatch('removeUser', {})
    //   this.$router.replace('/login')
    // },
    onRefresh () {
      this.$refs.appMain.refresh()
    },
    cancelPwd () {
      this.newPwd = ''
      this.oldPwd = ''
      this.repeatPwd = ''
      this.isSetShow = false
    },
    submitPwd () {
      if (!this.oldPwd) {
        this.$message.warning('请输入原密码')
        return
      }
      if (!this.newPwd) {
        this.$message.warning('请输入新密码')
        return
      }
      if (!this.repeatPwd) {
        this.$message.warning('请输入确认密码')
        return
      }
      if (this.repeatPwd !== this.newPwd) {
        this.$message.warning('确认密码与新密码不一致！')
        return
      }
      if (this.oldPwd === this.newPwd) {
        this.$message.warning('新密码和原密码一致，请设置不同的新密码！')
        return
      }
      let that = this
      this.axios.post('employee/modifyPassword', this.qs.stringify({ oldPassword: this.oldPwd, password: this.newPwd })).then(res => {
        if (res.data.success) {
          this.$confirm('修改成功，点击确定重新登录?', '提示', {
            confirmButtonText: '确定',
            closeOnClickModal: false,
            closeOnPressEscape: false,
            showCancelButton: false,
            showClose: false,
            type: 'warning'
          }).then(() => {
            that.$store.dispatch('removeUser', {})
            that.$router.replace('/login')
          })
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.main-container1 {
  position: absolute;
  top: 68px;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
}

.main-container {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue